import React from "react";
import { useParams } from "react-router-dom";
import { C } from "../../styles/tokens";
import PlanCardsGrid from "./PlanCardsGrid";

export default function ChooseAPlan() {
  const { org_id } = useParams();

  return (
    <div style={{ marginTop: 28, marginBottom: 32 }}>
      <h2 style={{ fontSize: 15, fontWeight: 700, color: C.n900, marginBottom: 14 }}>
        Choose a Plan
      </h2>
      <PlanCardsGrid
        org_id={org_id}
        onSuccess={() => window.location.reload()}
        source="billing_page"
      />
    </div>
  );
}
